import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";
class ClientFollowUp extends SmartModel {
	constructor (data) {
		super();
		
		this.appointmentGuid = "";
		this.body = "";
		this.clientGuid = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.extraData = {
			important: false,
			importantNotificationReceiver: [],
			reminder: {
				ts: "0000-00-00 00:00:00",
				type: "",
			},
		};
		this.guid = "";
		this.referenceClientName = "";
		this.referenceGuid = "";
		this.referenceType = "";
		this.status = 1; //1: normale, 3: bloccato
		this.type = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";

		this.__hasReminder = false;
		this.__importantNotificationsReceiverGuids = [];
		this.__index = 0;
		this.__isEditable = false;
		this.__referenceDeletedCSSClass = "";
		this.__referenceLabel = "";
		this.__reminderActivityType = "";
		this.__reminder_selected = true;
		this.__reminderDate = moment().add(1, "w").format("YYYY-MM-DD");
		this.__reminderIcon = "icon-alarm-clock";
		this.__reminderTypeLabel = "Promemoria";
		this.__reminderTime = moment().add(1, "w").format("HH:mm");
		this.__typeLabel = "";
		this.__userName = "";

		if (data) {
			this.import(data);
		}
	}

	export () {
		var exportData = this.__export();
		exportData.extraData = this.exportObjectField("extraData");
		return exportData;
	}

	import (data, options) {
		this.__import(data, options);

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY HH:mm");
		}
		this.importNumberField("status", data.status);
		this.importDateField("updatedAt", data.updatedAt);

		this.__isEditable = this.status !== 3 && (this.guid === "" || this.createdByGuid === Shark.$store.currUser.guid);

		let referenceType = this.referenceType;

		if (this.referenceType.slice(-4) === "_del") {
			referenceType = this.referenceType.slice(0, this.referenceType.length - 4);
			this.__referenceDeleted = true;
			this.__referenceDeletedCSSClass = "fu-reference-deleted";
		}

		this.__referenceLabel = Shark.$store.followUpReferenceMap[referenceType];

		const followUpTypeMap = Shark.$store.followUpTypeMap;
		if (this.type !== "system") {
			this.__typeLabel = followUpTypeMap[this.type];
		}
		else {
			this.__typeLabel = "Nota di sistema";
		}

		const user = Utils.safp(Shark.$store.userList, "guid", this.createdByGuid);
		if (user) {
			this.__userName = user.firstName + " " + user.lastName;
		}

		this.__hasReminder = this.appointmentGuid !== "";

		this.parseReminder();
	}

	on__hasReminderChanged () {
		//DAve: Ovviamente questo dovrebbe triggerare un render
		if (this.__hasReminder) {
			document.querySelectorAll(".setReminderOptions").forEach(item => item.classList.remove("disabled-node"));
		}
		else {
			document.querySelectorAll(".setReminderOptions").forEach(item => item.classList.add("disabled-node"));
		}
	}

	onExtraData_importantChanged () {
		//Dave: Un giorno trover� un modo per eliminare questa schifezza.
		const importantFollowUpReceiversBox = document.querySelector("#importantFollowUpReceiversBox");

		if (importantFollowUpReceiversBox) {
			if (this.extraData.important) {
				importantFollowUpReceiversBox.classList.remove("d-none");
			}
			else {
				importantFollowUpReceiversBox.classList.add("d-none");
			}
		}
	}

	onExtraData_reminder_typeChanged () {
		this.parseReminder();
	}

	parseReminder () {
		if (this.__hasReminder) {
			switch (this.extraData.reminder.type) {
				case "email":
					this.__reminderIcon = "icon-envelope";
					this.__reminderTypeLabel = "eMail";
					this.__email_selected = true;
					break;
				case "phone":
					this.__reminderIcon = "icon-phone";
					this.__reminderTypeLabel = "Telefonata";
					this.__phone_selected = true;
					break;
				case "visit":
					this.__reminderIcon = "icon-calendar-plus";
					this.__reminderTypeLabel = "Visita";
					this.__visit_selected = true;
					break;
				default:
					this.__reminderIcon = "icon-alarm-clock";
					this.__reminderTypeLabel = "Promemoria";
					this.__reminder_selected = true;
					break;
			}

			if (this.importDateField("extraData.reminder.ts", this.extraData.reminder.ts)) {
				this.__reminderDateLabel = this.extraData.reminder.ts.format("[Alle] HH:mm [del] DD/MM/YYYY");
				this.__reminderDate = this.extraData.reminder.ts.format("YYYY-MM-DD");
				this.__reminderTime = this.extraData.reminder.ts.format("HH:mm");
			}
		}
	}
}

Shark.registerModel("ClientFollowUp", ClientFollowUp);

export default ClientFollowUp;